import React from "react";
import { Button } from "reactstrap";

import celular from "assets/img/celular.png";
import telecoCar from "assets/img/teleco-car-2.PNG";

const COLORS = {
  bg: "#0b0b0f",
  purple: "#7b2cff",
  green: "#39ff14",
  text: "#e8e8ff",
  sub: "#a3a6af",
}; // a imagem que você mandou

const Landing = () => {
  const heroCtaScriptsRef = React.useRef(null);
  const finalCtaScriptsRef = React.useRef(null);
  const stickyCtaScriptsRef = React.useRef(null);
  const SCRIPTS_ENABLED = false;

  React.useEffect(() => {
    if (!SCRIPTS_ENABLED) return;
    const injectScriptsOnce = (container) => {
      if (!container || container.dataset.loaded === "1") return;

      const scripts = [
        // 1) PAGE VIEW NA ROI
        `
        function _0x58e9(){
          const _0x434161=['1780512RJjAty','POST','9590658iKebgu','27536620vAWjrc','352FuTBMk','Success:','currentScript','48kWDIxb','log','mOok-iK7D-zmX8-TvvO-p6cSqlkC1p','application/json','https://roi.metechsolucoes.com.br/pageViews/','success','862585WOmbVW','22443GHKnGO','status','then','catch','4603rIBEUX','1319985oJRwQA','stringify','error','104xjTXyF'];
          _0x58e9=function(){return _0x434161;};
          return _0x58e9();
        }
        function _0x4c12(_0x3024ca,_0x5237df){
          const _0x58e9fa=_0x58e9();
          return _0x4c12=function(_0x4c12c3,_0x1f0d4c){
            _0x4c12c3=_0x4c12c3-0x142;
            let _0x135ed9=_0x58e9fa[_0x4c12c3];
            return _0x135ed9;
          },_0x4c12(_0x3024ca,_0x5237df);
        }
        (function(_0x2fb6dc,_0x573205){
          const _0x3fccb4=_0x4c12,_0x21ce30=_0x2fb6dc();
          while(!![]){
            try{
              const _0x398243=parseInt(_0x3fccb4(0x146))/0x1*(parseInt(_0x3fccb4(0x14f))/0x2)+parseInt(_0x3fccb4(0x142))/0x3*(-parseInt(_0x3fccb4(0x14a))/0x4)+parseInt(_0x3fccb4(0x158))/0x5*(-parseInt(_0x3fccb4(0x152))/0x6)+-parseInt(_0x3fccb4(0x14d))/0x7+parseInt(_0x3fccb4(0x14b))/0x8+-parseInt(_0x3fccb4(0x147))/0x9+parseInt(_0x3fccb4(0x14e))/0xa;
              if(_0x398243===_0x573205)break;
              else _0x21ce30.push(_0x21ce30.shift());
            }catch(_0xef9acc){
              _0x21ce30.push(_0x21ce30.shift());
            }
          }
        }(_0x58e9,0xa9aa9),(function(){
          const _0x56aea=_0x4c12,
            _0x566aca=_0x56aea(0x154),
            _0x80f69='PageView',
            _0x1359a2=_0x56aea(0x156)+_0x566aca;
          fetch(_0x1359a2,{
            method:_0x56aea(0x14c),
            headers:{'Content-Type':_0x56aea(0x155)},
            body:JSON[_0x56aea(0x148)]({ev:_0x80f69})
          })
          [_0x56aea(0x144)](_0x249d8b=>_0x249d8b.json())
          .then(_0x192ca9=>{
            const _0x32c94d=_0x56aea;
            _0x192ca9[_0x32c94d(0x143)]===_0x32c94d(0x157)
              ? console[_0x32c94d(0x153)](_0x32c94d(0x150),_0x192ca9)
              : console[_0x32c94d(0x149)]('Erro ao registrar evento:',_0x192ca9);
          })
          [_0x56aea(0x145)](_0xf93f2d=>{
            const _0x5b81bc=_0x56aea;
            console[_0x5b81bc(0x149)]('Erro na requisição:',_0xf93f2d);
          });
        }()));
        `,

        // 2) PIXEL FB + PERFORMANCE OBSERVER
        `
        !function(f,b,e,v,n,t,s){
          if(f.fbq)return;
          n=f.fbq=function(){
            n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)
          };
          if(!f._fbq)f._fbq=n;
          n.push=n;
          n.loaded=!0;
          n.version='2.0';
          n.queue=[];
          t=b.createElement(e);
          t.async=!0;
          t.src=v;
          s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s);
        }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init','882232694376737');
        fbq('track','Check');
        console.log('Verificando [Check]');
        (function(){
          const observer = new PerformanceObserver((list) => {
            list.getEntries().forEach((b) => {
              if (b.name.includes('https://www.facebook.com/tr')) {
                console.log('Evento do Pixel capturado:', b);
                const c = new URL(b.name);
                const d = Object.fromEntries(c.searchParams.entries());
                d['client_user_agent'] = navigator.userAgent;
                fetch('https://api.ipify.org?format=json')
                  .then(r => r.json())
                  .then(a => {
                    d['client_ip'] = a.ip;
                    return fetch('https://roi.metechsolucoes.com.br/coletar-evento/mOok-iK7D-zmX8-TvvO-p6cSqlkC1p',{
                      method:'POST',
                      headers:{'Content-Type':'application/json'},
                      body: JSON.stringify(d)
                    });
                  })
                  .then(r => console.log('Evento enviado com sucesso:', r))
                  .catch(err => console.error('Erro ao enviar evento:', err));
              }
            });
          });
          observer.observe({ entryTypes:['resource'] });
        })();
        `,

        // 3) OUTRO PIXEL FB (940491240870685)
        `
        function _0xb9ab(_0x7c105e,_0x5be5fa){
          var _0x1f8780=_0x4a99();
          return _0xb9ab=function(_0x312c4d,_0x177496){
            _0x312c4d=_0x312c4d-0x199;
            var _0x39e55b=_0x1f8780[_0x312c4d];
            return _0x39e55b;
          },_0xb9ab(_0x7c105e,_0x5be5fa);
        }
        var _0x5a8ef9=_0xb9ab;
        function _0x4a99(){
          var _0x379187=['insertBefore','11905mnvOyn','callMethod','https://connect.facebook.net/en_US/fbevents.js','{}.constructor("return this")( )','queue','716pQPipk','209648NHyNzK','1058010BUaDMI','console','exception','2339870kBZPWC','createElement','207nNhmRu','return (function() ','16323736IdsdaS','search','prototype','7siFRSR','940491240870685','fbq','table','version','apply','_fbq','loaded','info','6rfQNpf','constructor','parentNode','push','src','log','(((.+)+)+)+$','init','track','2.0','691989MrOeBF','PageView','toString','675874DAgXfA','async','bind'];
          _0x4a99=function(){return _0x379187;};
          return _0x4a99();
        }
        (function(_0x2cc460,_0x348fdf){
          var _0x517ba3=_0xb9ab,_0x3ac797=_0x2cc460();
          while(!![]){
            try{
              var _0x564ce7=-parseInt(_0x517ba3(0x19f))/0x1+-parseInt(_0x517ba3(0x1a2))/0x2*(parseInt(_0x517ba3(0x1c0))/0x3)+parseInt(_0x517ba3(0x1ab))/0x4*(parseInt(_0x517ba3(0x1a6))/0x5)+parseInt(_0x517ba3(0x1ad))/0x6*(parseInt(_0x517ba3(0x1b7))/0x7)+-parseInt(_0x517ba3(0x1ac))/0x8*(parseInt(_0x517ba3(0x1b2))/0x9)+parseInt(_0x517ba3(0x1b0))/0xa+parseInt(_0x517ba3(0x1b4))/0xb;
              if(_0x564ce7===_0x348fdf)break;
              else _0x3ac797.push(_0x3ac797.shift());
            }catch(_0x134f1a){
              _0x3ac797.push(_0x3ac797.shift());
            }
          }
        }(_0x4a99,0x556c8),(console.log('Verificando [P]'),
        !function(_0x13e347,_0x4b66b2,_0x12a231,_0x3bc101,_0x3fabd7,_0x4a5f9d,_0x5af0b4){
          var _0x58290e=_0x5a8ef9;
          if(_0x13e347['fbq'])return;
          _0x3fabd7=_0x13e347['fbq']=function(){
            var _0x22da3e=_0x58290e;
            _0x3fabd7['callMethod']
              ? _0x3fabd7['callMethod']['apply'](_0x3fabd7,arguments)
              : _0x3fabd7['queue']['push'](arguments);
          };
          if(!_0x13e347['_fbq'])_0x13e347['_fbq']=_0x3fabd7;
          _0x3fabd7['push']=_0x3fabd7;
          _0x3fabd7['loaded']=!0x0;
          _0x3fabd7['version']='2.0';
          _0x3fabd7['queue']=[];
          _0x4a5f9d=_0x4b66b2['createElement'](_0x12a231);
          _0x4a5f9d['async']=!0x0;
          _0x4a5f9d['src']=_0x3bc101;
          _0x5af0b4=_0x4b66b2['getElementsByTagName'](_0x12a231)[0x0];
          _0x5af0b4['parentNode']['insertBefore'](_0x4a5f9d,_0x5af0b4);
        }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js'),
        fbq('init','940491240870685'),
        fbq('track','PageView')));
        `,

        // 4) SCRIPT DO HIPERLEAD (LIMPO, PARA AMBOS OS BOTÕES)
        `
        (function(){
          const TOKEN = "mOok-iK7D-zmX8-TvvO-p6cSqlkC1p";
          const CREATE_URL = "https://roi.metechsolucoes.com.br/createLink/" + TOKEN;
          const CALLBACK_URL = "https://callback.metechsolucoes.com.br/";

          document.querySelectorAll(".hiperlead").forEach(function(el){
            el.style.cursor = "pointer";

            el.addEventListener("click", function(){
              // Overlay
              const overlay = document.createElement("div");
              overlay.style.cssText =
                "position:fixed;top:0;left:0;width:100%;height:100%;" +
                "background-color:rgba(0,0,0,0.85);display:flex;" +
                "justify-content:center;align-items:center;z-index:999999;flex-direction:column;";

              const title = document.createElement("h2");
              title.textContent = "Redirecionando...";
              title.style.cssText =
                "color:#fff;font-family:Arial,sans-serif;font-size:2rem;" +
                "animation:pulse 1.5s infinite;";

              const countdown = document.createElement("div");
              countdown.style.cssText =
                "margin-top:10px;color:#ccc;font-family:Arial,sans-serif;font-size:1rem;";

              let sec = 10;
              countdown.textContent = "aguarde " + sec + "s...";

              const timer = setInterval(function(){
                sec--;
                countdown.textContent = "aguarde " + sec + "s...";
                if (sec <= 0) clearInterval(timer);
              }, 1000);

              overlay.appendChild(title);
              overlay.appendChild(countdown);
              document.body.appendChild(overlay);

              // animação pulse
              const style = document.createElement("style");
              style.textContent =
                "@keyframes pulse {0%{transform:scale(1);}50%{transform:scale(1.1);}100%{transform:scale(1);}}";
              document.head.appendChild(style);

              // fetch / redirect
              const controller = new AbortController();
              const timeout = setTimeout(function(){
                controller.abort();
              }, 10000);

              fetch(CREATE_URL, { method:"GET", signal: controller.signal })
                .then(function(r){ return r.json(); })
                .then(function(result){
                  clearTimeout(timeout);
                  clearInterval(timer);

                  if (result.status === "success" && result.invite_link) {
                    window.location.href = result.invite_link;
                  } else {
                    console.warn("Erro ao obter o link de convite:", result.message || "Erro desconhecido");
                    window.location.href = CALLBACK_URL;
                  }
                })
                .catch(function(err){
                  console.error("Erro na requisição:", err);
                  fetch(CALLBACK_URL + TOKEN, { method:"POST", keepalive:true });
                  window.location.href = CALLBACK_URL;
                });
            });
          });
        })();
        `
      ];

      scripts.forEach(code => {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.text = code;
        s.dataset.owner = "landing-scripts";
        container.appendChild(s);
      });

      container.dataset.loaded = "1";

      return () => {
        try {
          const nodes = Array.from(
            container.querySelectorAll('script[data-owner="landing-scripts"]')
          );
          nodes.forEach(n => n.remove());
          delete container.dataset.loaded;
        } catch (e) {}
      };
    };

    const cleanup = injectScriptsOnce(heroCtaScriptsRef.current);

    return () => {
      if (typeof cleanup === "function") cleanup();
    };
  }, [SCRIPTS_ENABLED]);

  return (
    <div className="content" style={{ padding: 0 }}>
      <style>{`
/* ROOT --------------------------------------------------------- */
.teleco-landing {
  width: 100%;
  min-height: 100vh;
  background:
    radial-gradient(900px 500px at 70% 10%, rgba(123,44,255,0.24), transparent),
    radial-gradient(900px 500px at 20% 0%, rgba(123,44,255,0.12), transparent),
    ${COLORS.bg};
  display: flex;
  justify-content: center;
  color: ${COLORS.text};
  position: relative;
  overflow-x: hidden;
}
.teleco-wrap {
  width: 100%;
  max-width: 520px; /* Mobile-first: largura de tela de celular */
  padding: 48px 18px 90px; /* espaço extra embaixo por causa do sticky CTA */
}

/* HERO --------------------------------------------------------- */
.hero {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 40px;
}

.hero-title {
  font-size: 28px;
  font-weight: 900;
  line-height: 1.12;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  background: linear-gradient(90deg, #ffffff 0%, ${COLORS.purple} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 0 18px rgba(123,44,255,0.3));
}

.hero-highlight {
  color: ${COLORS.green};
}

.hero-sub {
  font-size: 15px;
  color: ${COLORS.sub};
  margin-top: 8px;
}

/* BADGE --------------------------------------------------------- */
.badge-limited {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(123,44,255,0.25);
  border: 1px solid rgba(123,44,255,0.55);
  color: ${COLORS.text};
  font-weight: 600;
  font-size: 12px;
  animation: pulse 1.9s ease-in-out infinite;
}
.badge-limited i {
  color: ${COLORS.green};
}
@keyframes pulse {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(57,255,20,0.25) }
  50% { transform: scale(1.03); box-shadow: 0 0 0 12px rgba(57,255,20,0) }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(57,255,20,0) }
}

/* CTA ----------------------------------------------------------- */
.cta-primary {
  margin-top: 18px;
  font-weight: 800;
  font-size: 16px;
  padding: 14px 20px;
  border-radius: 12px;
  background: ${COLORS.green};
  color: #000;
  border: none;
  box-shadow: 0 0 20px rgba(57,255,20,0.45);
  width: 100%;
  transition: 0.25s;
}
.cta-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 30px rgba(57,255,20,0.65);
}
.hero-note {
  margin-top: 8px;
  font-size: 12px;
  color: ${COLORS.sub};
}

/* PHONE MOCK ---------------------------------------------------- */
.phone {
  width: 100%;
  max-width: 330px;
  height: 640px;
  border-radius: 42px;
  background: linear-gradient(140deg, rgba(123,44,255,0.5), rgba(123,44,255,0.12));
  box-shadow:
    inset 0 0 0 2px rgba(255,255,255,0.07),
    0 0 80px rgba(123,44,255,0.35);
  position: relative;
  margin: 8px auto 0;
}
.phone-glow {
  position: absolute;
  inset: -20px;
  border-radius: 52px;
  background: radial-gradient(600px 300px at 50% 0%, rgba(123,44,255,0.35), transparent);
  filter: blur(16px);
}
.screen {
  position: absolute;
  inset: 14px;
  border-radius: 30px;
  background: #0f0f15;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.07);
}
.statusbar {
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  font-size: 13px;
  color: #d7d7e8;
}
.chart {
  position: absolute;
  inset: 42px 0 0 0;
}
.chart img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 0;
}

/* SECTIONS TITLES ----------------------------------------------- */
.section-title {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.2px;
  margin-bottom: 8px;
}
.subtext {
  color: ${COLORS.sub};
  font-size: 13px;
  margin-bottom: 14px;
}

/* METRICS ------------------------------------------------------- */
.metrics-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 18px;
}
.metric-box {
  background: rgba(17,17,24,0.9);
  border-radius: 14px;
  padding: 10px 12px;
  border: 1px solid rgba(123,44,255,0.3);
  box-shadow: 0 0 18px rgba(123,44,255,0.18);
}
.metric-label {
  font-size: 11px;
  color: ${COLORS.sub};
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.metric-value {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 800;
}
.metric-helper {
  font-size: 11px;
  color: ${COLORS.sub};
  margin-top: 2px;
}

/* X-CARD TESTIMONIALS ------------------------------------------ */
.tweet-section {
  margin-top: 16px;
}
.tweet-section-title {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 6px;
}
.tweet-section-sub {
  font-size: 12px;
  color: ${COLORS.sub};
  margin-bottom: 10px;
}
.tweet-wrapper {
  border-radius: 18px;
  overflow: hidden;
}

/* STEPS -------------------------------------------------------- */
.steps {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 28px;
}
.step-card {
  background: rgba(17,17,24,0.95);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.06);
  padding: 12px 12px 10px;
}
.step-number {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 2px solid ${COLORS.green};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 12px;
  margin-bottom: 6px;
}
.step-title {
  font-weight: 700;
  font-size: 13px;
  margin-bottom: 4px;
}
.step-text {
  font-size: 12px;
  color: ${COLORS.sub};
}

/* FEATURES ----------------------------------------------------- */
.features {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 28px;
}
.feature {
  background: rgba(17,17,24,0.9);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 14px;
  padding: 12px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 0 16px rgba(123,44,255,0.18);
}
.feature i { color: ${COLORS.green}; margin-right: 6px; }
.feature small {
  display: block;
  margin-top: 3px;
  font-weight: 400;
  color: ${COLORS.sub};
  font-size: 11px;
}

/* RESGATE BOX --------------------------------------------------- */
.rescue-box {
  background: linear-gradient(90deg, rgba(123,44,255,0.22), rgba(123,44,255,0.04));
  border-radius: 16px;
  border: 1px solid rgba(123,44,255,0.4);
  padding: 14px 12px;
  margin-bottom: 24px;
  box-shadow: 0 0 22px rgba(123,44,255,0.25);
}
.rescue-text-main {
  font-weight: 800;
  font-size: 14px;
}
.rescue-text-sub {
  font-size: 11px;
  color: ${COLORS.sub};
  margin-top: 4px;
}

/* GUARANTEE / RESPONSABILIDADE --------------------------------- */
.guarantee {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}
.seal {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(17,17,24,0.8);
  border: 1px solid rgba(255,255,255,0.06);
  padding: 6px 8px;
  border-radius: 10px;
  font-size: 11px;
}
.seal i {
  color: ${COLORS.purple};
}

/* FINAL TEXT --------------------------------------------------- */
.final-cta-text-main {
  font-weight: 800;
  font-size: 14px;
  margin-bottom: 4px;
}
.final-cta-text-sub {
  font-size: 11px;
  color: ${COLORS.sub};
}

/* STICKY BOTTOM CTA (MOBILE) ----------------------------------- */
.sticky-cta {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(5,5,10,0.98);
  border-top: 1px solid rgba(123,44,255,0.4);
  padding: 10px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 50;
}
.sticky-label {
  font-size: 11px;
  color: ${COLORS.sub};
}
.sticky-cta-button {
  font-weight: 800;
  font-size: 14px;
  padding: 10px 16px;
  border-radius: 999px;
  background: ${COLORS.green};
  color: #000;
  border: none;
  box-shadow: 0 0 16px rgba(57,255,20,0.45);
}
.sticky-cta-button:hover {
  transform: translateY(-1px);
}

/* Em telas maiores, mantemos layout compacto no centro ---------- */
@media(min-width: 900px) {
  .teleco-wrap {
    max-width: 520px;
    padding-top: 64px;
  }
}

/* FOUNDER / TELECO SECTION ------------------------------------ */
.founder {
  background: radial-gradient(600px 300px at 50% 0%, rgba(123,44,255,0.18), transparent),
              rgba(10,10,16,0.95);
  border-radius: 18px;
  border: 1px solid rgba(123,44,255,0.4);
  padding: 14px 12px;
  margin-bottom: 28px;
  box-shadow: 0 0 22px rgba(123,44,255,0.25);
}

.founder-title {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 4px;
}

.founder-sub {
  font-size: 12px;
  color: ${COLORS.sub};
  margin-bottom: 10px;
}

.founder-photo-wrapper {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.06);
}

.founder-photo {
  width: 100%;
  display: block;
  object-fit: cover;
}
      `}</style>

      {/* ===================== PAGE ===================== */}
      <div className="teleco-landing">
        <div className="teleco-wrap" id="top">

          {/* HERO */}
          <div className="hero mt-0">
            <div>
              <div className="badge-limited mb-2">
                <i className="fas fa-bolt" />
                OFERTA POR TEMPO LIMITADO: OFERTA POR TEMPO LIMITADO: ACESSO GRATUITO + R$10 DE SALDO
              </div>

              <h1 className="hero-title">
                Resgate <span className="hero-highlight">acesso gratuito</span> ao app
                <br />
                + R$10 para testar o app
                <br />
                buscando até R$1.000 por dia usando o aplicativo.
              </h1>

              <p className="hero-sub">
                Você vai acessar gratuitamente o aplicativo profissional do Teleco, usar as mesmas leituras
                e alertas que ele usa nas operações e ainda receber R$10 para testar na prática dentro da
                casa indicada.
              </p>

              <Button
                className="cta-primary"
                href="https://chat.whatsapp.com/Fi6YSBe9aFPKvScuq8bcNk"
              >
                RESGATAR ACESSO GRÁTIS + R$10
              </Button>
              <div ref={heroCtaScriptsRef} />

              <div className="hero-note">
                Oferta liberada para poucos jogadores por vez. Ao clicar, você será direcionado para o meu atendimento para resgatar o acesso gratuito e ativar os R$10 de teste.
              </div>
            </div>

            <div>
              <div className="phone">
                <div className="phone-glow" />
                <div className="screen">
                  <div className="statusbar">
                    <span>Teleco App</span>
                    <span><i className="fas fa-signal" /> <i className="fas fa-battery-full" /></span>
                  </div>
                  <div className="chart">
                    <img src={celular} alt="Tela do aplicativo do Teleco" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* QUEM ESTÁ POR TRÁS DO APP */}
          <div className="founder">
            <div className="founder-title">Quem está por trás do aplicativo</div>
            <p className="founder-sub">
              Meu nome é Teleco. Eu vivo do mercado de cassinos online, operando forte no Aviator
              e desenvolvendo ferramentas profissionais para leitura de gráfico, gestão de banca
              e automação de sinais. Este app é exatamente o painel que uso nas minhas operações.
            </p>

            <div className="founder-photo-wrapper">
              <img
                src={telecoCar}
                alt="Teleco em um carro conversível, representando liberdade financeira"
                className="founder-photo"
              />
            </div>
          </div>

          {/* COMO FUNCIONA A OFERTA NA PRÁTICA 
          <div style={{ marginTop: 28 }}>
            <div className="section-title">Como funciona a oferta de 3 dias + R$10</div>
            <p className="subtext">
              Tudo é simples, direto e pensado pra você testar o app na prática antes de decidir se continua.
            </p>

            <div className="steps">
              <div className="step-card">
                <div className="step-number">1</div>
                <div className="step-title">Você resgata o acesso</div>
                <div className="step-text">
                  Clica no botão, faz o cadastro e recebe 3 dias de acesso total ao app do Teleco, deposita R$10 e ganha mais R$10
                  para testar na casa indicada.
                </div>
              </div>

              <div className="step-card">
                <div className="step-number">2</div>
                <div className="step-title">Usa o app por 3 dias completos</div>
                <div className="step-text">
                  Durante o período de teste, você pode explorar o painel, seguir os alertas, usar a gestão de banca
                  e entender como o app lê o Aviator.
                </div>
              </div>

              <div className="step-card">
                <div className="step-number">3</div>
                <div className="step-title">Decide se continua</div>
                <div className="step-text">
                  Se fizer sentido pra você, continua com o plano profissional. Se não fizer, você já teve 3 dias de acesso
                  e ainda testou com R$10 de saldo. Simples.
                </div>
              </div>
            </div>
          </div>

          {/* O QUE O APP ENTREGA (FOCO EM R$1.000/DIA) 
          <div>
            <div className="section-title">O que o app te entrega pra buscar a meta diária</div>
            <p className="subtext">
              O foco é te dar visão, leitura e gestão pra você ter chance real de buscar até R$1.000/dia com consistência,
              e não só na sorte.
            </p>

            <div className="features">
              <div className="feature">
                <i className="fas fa-bolt" />
                Sinais inteligentes em tempo real
                <small>Alertas alinhados com padrões de multiplicadores que podem levar você à meta diária.</small>
              </div>
              <div className="feature">
                <i className="fas fa-robot" />
                Gestão de banca guiada
                <small>Estruturas de entrada e saída pensadas pra proteger sua banca e reduzir decisões no impulso.</small>
              </div>
              <div className="feature">
                <i className="fas fa-chart-line" />
                Histórico completo do Aviator
                <small>Sequência de baixos, velas rosas, padrões visuais e leitura rápida da fase do jogo.</small>
              </div>
              <div className="feature">
                <i className="fas fa-fire" />
                Alertas de velas rosas (10x+)
                <small>Monitoramento dedicado às melhores oportunidades do gráfico.</small>
              </div>
              <div className="feature">
                <i className="fas fa-percentage" />
                Probabilidades avançadas
                <small>Estimativas pra filtrar entradas ruins e focar nas melhores janelas de risco-retorno.</small>
              </div>
              <div className="feature">
                <i className="fas fa-users" />
                Mentalidade de player profissional
                <small>O app foi desenhado pra tirar você do modo amador e levar pro jogo de forma estruturada.</small>
              </div>
            </div>
          </div>*/}

          {/* BOX DE RESGATE */}
          <div id="resgate" className="rescue-box">
            <div className="rescue-text-main">
              Resgate seu acesso gratuito ao app + R$10 de SALDO enquanto a oferta está ativa.
            </div>
            <div className="rescue-text-sub">
              Ao clicar no botão, você será direcionado ao meu atendimento para ativar seu acesso gratuito e liberar os R$10 para testar na prática.
            </div>
          </div>

          {/* GARANTIA / RESPONSABILIDADE */}
          <div className="guarantee">
            <div className="seal">
              <i className="fas fa-certificate" />
              Ferramenta oficial do Teleco
            </div>
            <div className="seal">
              <i className="fas fa-check" />
              App focado em análise, não promessa de lucro garantido
            </div>
            <div className="seal">
              <i className="fas fa-plus" />
              18
            </div>
          </div>

          {/* TEXTO FINAL */}
          <div style={{ marginBottom: 16 }}>
            <div className="final-cta-text-main">
              Você tem acesso gratuito + R$10 pra descobrir, na prática, se esse app faz sentido pra você.
            </div>
            <div className="final-cta-text-sub">
              Pode continuar no improviso ou testar, de graça, a ferramenta que o Teleco usa para operar no Aviator.
              A próxima rodada está rodando agora.
            </div>
          </div>

          <Button
            className="cta-primary"
            href="https://chat.whatsapp.com/Fi6YSBe9aFPKvScuq8bcNk"
          >
            QUERO MEUS 3 DIAS GRÁTIS + R$10
          </Button>
          <div ref={finalCtaScriptsRef} />

        </div>

        {/* STICKY CTA MOBILE */}
        <div className="sticky-cta">
          <div className="sticky-label">
            Oferta ativa: acesso gratuito + R$10 para testar o app na prática.
          </div>
          <Button
            className="sticky-cta-button"
            href="https://chat.whatsapp.com/Fi6YSBe9aFPKvScuq8bcNk"
          >
            RESGATAR ACESSO GRÁTIS + R$10 AGORA
          </Button>
          <div ref={stickyCtaScriptsRef} />
        </div>
      </div>
    </div>
  );
};

export default Landing;
